export default "__VITE_ASSET__q9gorjKxCD0en$559AoW_g__"